<template lang="pug">
  div(:class='typeaheadState')
    .typeahead__toggle(ref='toggle' @mousedown.prevent='toggle')
      input.typeahead__search(
        type='text',
        ref='search',
        v-model='search',
        @focus='onFocus', 
        @blur='onBlur', 
        @keydown.esc='onEscape',
        @keydown.down='onDownKey',
        @keydown.up='onUpKey',
        @keydown.enter='onEnterKey',
        @keydown.tab='onTabKey',
        :disabled='isDisabled'
        )
      span.typeahead__text(ref='text') {{displayText}}
    ul.typeahead__list(ref='list' v-if='open')
      li.typeahead__item(v-for='(option, index) in filteredOptions' :key='index')
        a.typeahead__link(@mousedown.prevent='select(option)' :class="[selectIndex === index ? 'typeahead__active':'']")
          | {{option.pg}}
</template>
<script type="text/javascript">
  export default {
    props: {
      options: {
        type: Array,
        default () {
          return []
        }
      },
      optionSelect: {
        type: Object,
        default () {
          return {}
        }
      },
      isDisabled: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        open: false,
        selectIndex: 0,
        displayText: '',
        search: ''
      }
    },
    watch: {
      optionSelect () {
        this.displayText = this.optionSelect.pg
      },
      search () {
        this.search = this.search.toUpperCase()
      }
    },
    computed: {
      typeaheadState () {
        return this.open ? 'typeahead typeahead__open' : 'typeahead'
      },
      filteredOptions () {
        const exp = new RegExp(this.search, 'i')
        return this.options.filter((option) => {
          return (exp.test(option.pg) || exp.test(option.pg))
        })
      }
    },
    methods: {
      onDownKey () {
        if (this.filteredOptions.length - 1 > this.selectIndex) {
          this.selectIndex++
          // scroll when overflow
          if (this.selectIndex > 2) {
            this.$refs.list.scrollTop += (20 + this.selectIndex)
          }
        }
      },
      onUpKey () {
        if (this.selectIndex > 0) {
          this.selectIndex--
          // scroll when overflow
          if (this.selectIndex > 0) {
            this.$refs.list.scrollTop -= (20 + this.selectIndex)
          }
        }
      },
      onEnterKey () {
        const option = this.filteredOptions[this.selectIndex]
        if (option) {
          this.select(option)
        } else {
          const pgSinEspaciosAlFinal = this.search.trim()
          const pgSinEspacios = pgSinEspaciosAlFinal.replace(/\s+/g, '')
          const pgConGuion = pgSinEspacios.includes('-')
          if (!pgConGuion) {
            this.$emit('error', 'Revise la sintaxis del Autotanque')
            return
          }
          const myObj = {
            pg: pgSinEspacios
          }
          this.$emit('input', myObj)
        }
      },
      onTabKey() {
        const pgSinEspaciosAlFinal = this.search.trim()
        const pgSinEspacios = pgSinEspaciosAlFinal.replace(/\s+/g, '')
        const pgConGuion = pgSinEspacios.includes('-')
        if (!pgConGuion) {
          this.$emit('error', 'Revise la sintaxis del Autotanque')
          return 
        }
        const myObj = {
          pg: pgSinEspacios
        }
        console.log(myObj)
        this.$emit('input', myObj)
      },

      select (option) {
        this.displayText = option.pg
        this.$emit('input', (option))
        this.$refs.search.blur()
      },
      toggle (e) {
        if (e.target === this.$refs.toggle ||
          e.target === this.$refs.search ||
          e.target === this.$refs.text) {
          if (this.open) {
            if (e.target !== this.$refs.search &&
              e.target !== this.$refs.text) {
              this.$refs.search.blur()
            }
          } else {
            this.$refs.search.focus()
          }
        }
      },
      onFocus () {
        this.open = true
      },
      onBlur () {
        this.search = ''
        this.selectIndex = 0
        this.$refs.list.scrollTop = 0
        this.open = false
      },
      onEscape () {
        this.$refs.search.blur()
      }
    }
  }
</script>

<style scoped>
    .typeahead::-webkit-scrollbar {
      width: 7px;
      background: #00d1b2;
    }
    .typeahead::-webkit-scrollbar-thumb {
      background: #f4f4f4;
      border-radius: 10px;
      border-right: 2px solid #00d1b2;
    }
    .typeahead {
      border-radius: 3px;
      border: 1px solid #00d1b2;
      position: relative;
      z-index: 1;
      width: 100%;
      font-size: 14px;
      font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    }
    .typeahead__open {
        border: 1px solid #00d1b2;
    }
    .typeahead__open .typeahead__text {
        color: #ffffff;
        opacity: 0.4;
    }
    .typeahead__toggle {
        position: relative;
        z-index: 1;
        width: 100%;
    }
    .typeahead__search {
      position: absolute;
      top: 0;
      left: 0;
      line-height: 1em;
      font-size: 1em;
      padding: 10px;
      width: 100%;
      display: block;
      cursor: text;
      background: transparent;
      border: none;
      outline: none;
      z-index: 2;
    }
    .typeahead__text {
      min-height: 36px;
      font-size: 1em;
      line-height: 1em;
      padding: 10px;
      display: inline-block;
      position: relative;
      z-index: 3;
    }
    .typeahead__list {
        margin: 0;
        padding: 0;
        max-height: 300px;
        overflow-y: scroll;
    }
    .typeahead__item:hover {
      background: #00d1b2;
      color: #fff;
    }

    .typeahead__item {
        display: block;
        border-top: 1px solid #f4f4f4;
    }
    .typeahead__link {
        display: block;
        padding: 10px;
        line-height: 1em;
        font-size: 1em;
        cursor: pointer;
    }
    .typeahead__active {
        background: #00d1b2;
        color: #fff;
    }

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/accesos/componentes/TypeaheadPG.vue